module.exports = __webpack_public_path__ + "img/fashion_96.3d12872f.jpg";